import { Link, useLocation } from "react-router-dom";

export default function Footer() {
    const loc = useLocation();
    if (loc.pathname.startsWith("/u/") || loc.pathname === "/auth-callback") return null;
    return (
        <footer className="border-t border-white/5 py-10 relative z-10">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8 items-center">
                <div className="flex justify-center md:justify-start">
                    <img
                        src="/connexa-logo.png"
                        alt="Connexa"
                        className="h-24 md:h-28 w-auto object-contain opacity-95 drop-shadow-[0_0_18px_rgba(16,185,129,0.25)]"
                    />
                </div>

                <div className="text-center">
                    <div className="text-xs text-brand-400 italic mb-1">Every Scan Starts a Conversation</div>
                    <div className="text-sm text-gray-300 space-y-0.5">
                        <div>
                            <a href="mailto:Support@connexa.co.in" className="hover:text-brand-400 transition-colors" data-testid="footer-email">
                                Support@connexa.co.in
                            </a>
                        </div>
                        <div>
                            <a href="tel:+919136581868" className="hover:text-brand-400 transition-colors" data-testid="footer-phone">
                                +91 91365 81868
                            </a>
                        </div>
                    </div>
                    <div className="text-xs text-gray-500 mt-2">© 2026 Connexa. All rights reserved.</div>
                </div>

                <div className="flex gap-6 text-sm text-gray-500 justify-center md:justify-end">
                    <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy</Link>
                    <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Terms</Link>
                    <Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact">Contact</Link>
                </div>
            </div>
        </footer>
    );
}
